function getInitialState(isPreview = false) {
  return isPreview;
}
function getIsPreview(state) {
  return state;
}
function reducer(state = getInitialState(), action) {
  switch (action.type) {
    default:
      return state;
  }
}
export {
  getInitialState,
  getIsPreview,
  reducer
};
//# sourceMappingURL=is-preview.js.map